<template>
  <div class="Contact">
    <PageHero title="Contact" lede="Tell us a little about your company and what you are trying to do." />
    <section class="section">
      <div class="container">
        <div class="split">
          <div>
            <div v-if="state === 'sent'" class="notice ok" role="status">
              <h3>Thanks for contacting us.</h3>
              <p>We will be in touch.</p>
            </div>
            <form v-else class="form" @submit.prevent="sendEmail">
              <div v-if="state === 'error'" class="notice err" role="alert">
                Sorry, something went wrong sending your message. Please try
                again or email
                <a href="mailto:brian@tenfactorgrowth.com">brian@tenfactorgrowth.com</a>.
              </div>
              <div class="two">
                <div>
                  <label for="name">Name *</label>
                  <input id="name" type="text" required v-model="data.name" autocomplete="name">
                </div>
                <div>
                  <label for="email">Email *</label>
                  <input id="email" type="email" required v-model="data.email" autocomplete="email">
                </div>
              </div>
              <div>
                <label for="phone">Phone</label>
                <input id="phone" type="text" v-model="data.phone" autocomplete="tel">
              </div>
              <div>
                <label for="message">Message</label>
                <textarea id="message" v-model="data.message"></textarea>
              </div>
              <div>
                <button class="btn" type="submit" :disabled="state === 'sending'">
                  {{ state === 'sending' ? 'Sending...' : 'Send message' }}
                </button>
              </div>
            </form>
          </div>
          <div class="stack">
            <h3>Other ways to reach us</h3>
            <p><a href="mailto:brian@tenfactorgrowth.com">brian@tenfactorgrowth.com</a><br>
              Boston, Massachusetts</p>
            <p><a href="https://www.linkedin.com/in/brianeberman/" target="_blank" rel="noopener">LinkedIn</a></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import emailjs from 'emailjs-com'
import PageHero from '@/components/PageHero'

const templateID = 'template_1xg64at'
const serviceID = 'service_s10rfcw'
const userID = 'user_s7hOeL0CUUH0Tf0wJlTaT'
emailjs.init(userID)

export default {
    title: 'Contact - Ten Factor Growth',
    components: { PageHero },
    data() {
        return {
            state: 'input', // input | sending | sent | error
            data: { name: null, email: null, phone: null, message: null }
        }
    },
    methods: {
        sendEmail() {
            this.state = 'sending'
            emailjs.send(serviceID, templateID, this.data, userID)
                .then(() => { this.state = 'sent' })
                .catch((error) => {
                    console.log('FAILED...', error)
                    this.state = 'error'
                })
        }
    }
}
</script>
